import { render } from "./mainFooter.vue?vue&type=template&id=ad8515d2&scoped=true&ts=true"
import script from "./mainFooter.vue?vue&type=script&lang=ts"
export * from "./mainFooter.vue?vue&type=script&lang=ts"

import "./mainFooter.vue?vue&type=style&index=0&id=ad8515d2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad8515d2"]])

export default __exports__